
import React from 'react';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from '@/components/ui/table';

interface TransfersTabProps {
  transfers: any[];
  date?: Date;
}

export const TransfersTab: React.FC<TransfersTabProps> = ({ transfers, date }) => {
  const { t } = useTranslation();

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
  };

  if (transfers.length === 0) {
    return (
      <div className="text-center py-6 text-muted-foreground">
        {date ? 
          t('history.noTransfersDate', { date: format(date, 'dd/MM/yyyy') }) : 
          t('history.noTransfers')}
      </div>
    );
  }

  return (
    <div className="max-h-[50vh] overflow-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>{t('history.fields.amount')}</TableHead>
            <TableHead>{t('history.fields.recipient')}</TableHead>
            <TableHead>{t('history.fields.date')}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {transfers.map((transfer: any, index: number) => (
            <TableRow key={index}>
              <TableCell>{transfer.amount} DJF</TableCell>
              <TableCell>{transfer.recipientnumber}</TableCell>
              <TableCell>{formatDate(transfer.date)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
